// import { Report } from "../../interfaces/intakes.reports"

// interface Props{
//     data: Report
// }
// export const PDFSummary = ({data}:Props) => {
//   return (
//     <PDFPage data={data}>
//                         <Text style={globalStyles.h2}>Batch Images</Text>
//                         <PDFImages images={data.mainDataImages} />
//                     </PDFPage>
//   )
// }

import { Report } from "../../interfaces/intakes.reports"
import { View, Text, Image } from "@react-pdf/renderer"
import { globalStyles } from "./DocuPdf"
import { PDFImages } from "./PDFImages"
import { PDFPage } from "./PDFPage"
import { PDFWeather } from "./PDFWeather"
import { HTMLtoPDF } from "../customs/HTML-Text/HTMLtoPDF"
import { PDFMainData } from "./PDFMainData"
import { PDFPalletsSummary } from "./PDFPalletsSummary"
import { PDFCreatedBy } from "./PDFCreatedBy"


interface Props {
    data: Report
}
export const PDFSummary = ({ data }: Props) => {

    return (
        <>
            <PDFPage data={data} wrap={false} disabledHeader>

                <View style={{ flexDirection: 'row', paddingBottom: 5, justifyContent: 'space-between', alignItems: 'center', borderBottomColor: 'gray', borderBottomWidth: .5, marginBottom: 20 }}>
                    <Text style={[globalStyles.bold, globalStyles.textGreen]}>Summary</Text>
                    <Image
                        src="../../assets/img/qc-logo-color.png"
                        style={{ width: "60px", height: "auto" }}
                    />
                </View>
                
                <PDFMainData data={data} />

                <View style={{ marginBottom: 10 }}>

                    <View style={[globalStyles.comments, { marginBottom: 15 }]}>
                        <Text style={[globalStyles.h2, { marginBottom: 10 }]}>Pallets Summary</Text>
                        {data.pallets && data.pallets.length > 0
                            ?
                            data.pallets.map((pallet, index) => (
                                <PDFPalletsSummary key={pallet.pid + index} pallet={pallet} data={data} index={index}/>
                            ))

                            // {/* <View style={[globalStyles.item, styles.defectsHeader]}>
                            //     <Text style={[globalStyles.text, globalStyles.bold, { width: '25%' }]}>Item</Text>
                            //     <Text style={[globalStyles.text, globalStyles.bold, { width: '25%', color: 'red' }]}>Major Defect (Critical)</Text>
                            //     <Text style={[globalStyles.text, globalStyles.bold, { width: '25%', color: 'orange' }]}>Minor Defect</Text>
                            //     <Text style={[globalStyles.text, globalStyles.bold, { flex: 1 }]}>Score</Text>
                            // </View> */}

                            : <Text style={{ color: '#878787', fontSize: '8.5px', lineHeight: '1.4px' }}>No pallets data</Text>}
                    </View>

                    {
                        (data.weather && data.weather.length > 0) &&
                        <View style={{ marginBottom: 15 }}>
                            <Text style={[globalStyles.h2, { marginBottom: 10 }]}>Weather before harvest</Text>
                            {
                                data.weather.map((location, index) => (
                                    <PDFWeather key={index} location={location} />
                                ))
                            }
                        </View>

                    }

                    <View style={[globalStyles.comments, { marginBottom: 15 }]}>
                        <Text style={[globalStyles.h2, { marginBottom: 10 }]}>General Comments</Text>
                        {/* <HTMLtoPDF html={data.comments} /> */}
                        {data.comments ? <HTMLtoPDF html={data.comments} /> : null}
                    </View>

                </View>

                {
                    data.mainDataImages && data.mainDataImages.length > 0 &&
                    <>
                        <Text style={[globalStyles.h2, { marginBottom: 10 }]}>Batch Images</Text>
                        <PDFImages images={data.mainDataImages} />
                    </>
                }
            </PDFPage>
        </>
    )
}
